import { oneApi } from 'config/api'

// 默认卡片模式
const DEFAULT_COURSE_MODE = 'card'

export default {
  data() {
    const langContext = this.$t('featureComponents.CoursesResults')
    return {
      langContext,
      pageSize: 15, // 每页加载条数
      pageNum: 1, // 当前页码
      total: 0, // 数据总条数
      loading: true, // 加载中
      isError: false, // 是否出错
      isEmpty: false, // 是否空数据
      filterList: [], // 筛选数据列表
      coursesModeCache: '', // 课程卡片模式缓存
      coursesList: [], // 课程列表数据
      errorNotice: '', // 错误提示
      emptyNotice: langContext.emptyNotice, // 空数据提示
      filtersParams: [], // 筛选参数
    }
  },
  async asyncData({ $axios }) {
    const res = await $axios.post(oneApi.queryCourseSelector, {}, { rewritePostBody: true })
    const { code, data = {} } = res
    if (code !== 0) {
      return {
        filterList: [],
        defaultCoursesMode: DEFAULT_COURSE_MODE,
      }
    }
    const { filter: filterList = [], displayMode: defaultCoursesMode = DEFAULT_COURSE_MODE } = data

    /* eslint-disable */
    console.log('筛选器的接口返回数据 filterList:', JSON.stringify(filterList))
    return {
      filterList,
      defaultCoursesMode,
    }
  },
  computed: {
    // 课程卡片模式
    coursesMode() {
      return this.coursesModeCache || this.defaultCoursesMode
    },

    // 初始Loading
    firstLoading() {
      return this.loading && this.pageNum === 1
    },

    // 首页加载
    firstLoadend() {
      return !this.loading && this.pageNum === 1
    },

    // 是否加载数据完成
    loadend() {
      return !(this.coursesList.length < this.total && this.coursesList.length !== 0)
    },

    // 显示请求错误状态
    showErrorStatus() {
      return this.isError
    },

    // 显示空数据状态
    showEmptyStatus() {
      return this.firstLoadend && this.coursesList.length === 0
    },
  },
  mounted() {
    this.setCoursesModeCache()
    this.queryCoursesList()
    this.Sensors.track('course_list_pv')
  },
  methods: {
    /**
     * 查询课程列表数据
     */
    async queryCoursesList(type) {
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        filter: this.filtersParams,
      }

      this.loading = true

      const res = await this.$axios.post(oneApi.queryCourseListV3, params, { rewritePostBody: true })
      const { code, msg, data = {} } = res

      this.loading = false

      if (!res || code !== 0) {
        this.errorNotice = msg || this.langContext.errorNotice
        this.isError = true
        return
      }

      const { total = 0, list = [] } = data
      this.isError = false
      this.total = total
      this.coursesList = this.coursesList.concat(list)

      if (type === 'scroll' && this.coursesList.length === 30 && this.total > 30) {
        this.pageSize = 30
        this.pageNum = 1
      }
      const queryNames = this.flattenFilterNames(params.filter, this.filterList);
      const title = `${this.$store.state.website.page.title}` + queryNames.join();
      const keywords = `${this.$store.state.website.page.keywords}` + queryNames.join();
      const description = `${this.$store.state.website.page.description}` + queryNames.join();
      const seoParams = {
        description,
        title,
        keywords,
        isDefault: '',
      };
      this.$store.dispatch('website/updatePageData', seoParams);
    },

    /**
     * 课程卡片模式切换
     * @param {String} mode 卡片模式
     */
    handleCoursesModeChange(mode) {
      this.pageNum = 1
      this.coursesList = []
      this.updateCoursesModeCache(mode)
      this.queryCoursesList()
    },

    /**
     * 加载更多
     */
    handleLoadMore(value) {
      if (this.loadend || (this.pageSize === 30 && value === 'scroll')) return
      this.pageNum += 1
      this.queryCoursesList(value)
    },

    /**
     * 重试
     */
    handleRetry() {
      this.pageNum = 1
      this.coursesList = []
      this.queryCoursesList()
    },

    /**
     * 处理筛选项变化事件
     * @param {Array} filters 筛选项列表
     */
    handleFilterChange(filters) {
      this.pageNum = 1
      this.coursesList = []
      this.filtersParams = filters
      this.queryCoursesList()
    },

    /**
     * 更新筛选参数
     * @param {Array} filters 筛选项列表
     */
    updateFilterParams(filters) {
      this.filtersParams = filters
    },

    /**
     * 获取课程卡片模式缓存
     */
    setCoursesModeCache() {
      const coursesModeCache = window.localStorage.getItem('_official_courses_mode') || ''
      this.coursesModeCache = coursesModeCache
    },

    /**
     * 更新课程卡片模式缓存
     */
    updateCoursesModeCache(mode) {
      window.localStorage.setItem('_official_courses_mode', mode)
      this.coursesModeCache = mode
    },
    flattenFilterNames(filter, filterlist) {
      // 创建一个以 type 为键的 filterlist 映射，方便快速查找
      const filterlistMap = {};
      filterlist.forEach(item => {
        filterlistMap[item.type] = item.value;
      });
    
      // 收集所有匹配的 name 到一个数组中
      const allNames = [];
    
      filter.forEach(item => {
        const { type, keys } = item;
        const values = filterlistMap[type] || [];
        
        keys.forEach(key => {
          const valueItem = values.find(v => v.key === key);
          if (valueItem && valueItem.name) {
            allNames.push(valueItem.name);
          }
        });
      });
    
      return allNames;
    }
  },
}
